import { type Static, type TLiteral, type TSchema, type TUnion, Type } from "@sinclair/typebox";

/**
 * `readonly string[]` からリテラル union の schema を作る。
 *
 * `Type.Unsafe` で `{ type: "string", enum: [...] }` を書くと JSON Schema は小さくなるが、
 * Kind を持たないため Elysia の TypeCompiler が
 * `TypeCompilerUnknownTypeError` で落ちる。実体のある `Type.Union` で組む。
 *
 * `map` でタプル性が失われるだけなので、戻り値の型だけ絞り直している。
 */
export function StringEnum<const T extends readonly string[]>(
  values: T,
): TUnion<TLiteral<T[number]>[]> {
  return Type.Union(values.map((value) => Type.Literal(value))) as TUnion<TLiteral<T[number]>[]>;
}

/** TypeBox schema から静的型を取り出す別名。 */
export type Infer<T extends TSchema> = Static<T>;

export { Type };
